import { observer } from 'mobx-react';
import React from 'react';
import GoalsPool from '../../js/GoalsPool';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';
import './GoalsPopup.css';



const WinLoseGroups = ({groups}) => (
  groups.map((group, index) => (
    <div key={group.id}>
      <ul className="goals-group">
        {group.goals.map(g => <li key={g.id} dangerouslySetInnerHTML={{__html: g.translated_title}} />)}
      </ul>

      {(index + 1) < groups.length && <div>{store.t("goals_or")}</div>}
    </div>)
  )
)


const GoalsPopup = () => (
  <>
    <div className="overlay" onClick={() => PopupStore.close(POPUPS_IDS.GOALS)} />
    <div className="top-left-popup">
      <div className="GoalsPopup-win">
        <h5>{store.t("goals_win_if")}</h5>
        <WinLoseGroups groups={GoalsPool.victoryGroups} />
      </div>
      <div className="GoalsPopup-lose">
        <h5>{store.t("goals_lose_if")}</h5>
        <WinLoseGroups groups={GoalsPool.defeatGroups} />
      </div>
    </div>
  </>
)


export default observer(GoalsPopup)
